import { render, staticRenderFns } from "./CustomerBudgets.vue?vue&type=template&id=158093ce"
import script from "./CustomerBudgets.vue?vue&type=script&lang=js"
export * from "./CustomerBudgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports